// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__j10E7","consentsList":"PatientConsents_consentsList__7Mnou","consentsListEmpty":"PatientConsents_consentsListEmpty__1PFc3"};